import { RepositoryFirebase } from "../common/repository.firebase";
import { ProductCategory } from "./product-category.entity";

export class ProductCategoriesRepository extends RepositoryFirebase<ProductCategory> {
    protected collection = 'products-categories';
    protected entity = ProductCategory;
}

export const productCategoriesRepository = new ProductCategoriesRepository();